import React, { useMemo, useState } from 'react';
import { ImportEstado, ImportRow } from '../types/users.types';

const BADGE: Record<ImportEstado, string> = {
  crear: 'bg-blue-100 text-blue-800',
  creada: 'bg-green-100 text-green-800',
  omitir: 'bg-gray-100 text-gray-700',
  omitida: 'bg-gray-100 text-gray-700',
  error: 'bg-red-100 text-red-800',
};

type Filtro = 'todas' | 'crear' | 'omitir' | 'error';

const coincide = (estado: ImportEstado, filtro: Filtro): boolean => {
  if (filtro === 'todas') return true;
  if (filtro === 'crear') return estado === 'crear' || estado === 'creada';
  if (filtro === 'omitir') return estado === 'omitir' || estado === 'omitida';
  return estado === 'error';
};

export const ImportPreviewTable: React.FC<{ rows: ImportRow[] }> = ({ rows }) => {
  const [filtro, setFiltro] = useState<Filtro>('todas');

  const visibles = useMemo(
    () => rows.filter((r) => coincide(r.estado, filtro)),
    [rows, filtro],
  );

  return (
    <div>
      <div className="flex gap-2 mb-3">
        {(['todas', 'crear', 'omitir', 'error'] as Filtro[]).map((f) => (
          <button
            key={f}
            type="button"
            onClick={() => setFiltro(f)}
            className={`px-3 py-1 rounded text-sm border ${
              filtro === f ? 'bg-gray-900 text-white' : 'bg-white text-gray-700'
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      <div className="max-h-96 overflow-y-auto border rounded">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 sticky top-0">
            <tr>
              <th className="text-left px-3 py-2">Línea</th>
              <th className="text-left px-3 py-2">Email</th>
              <th className="text-left px-3 py-2">Estado</th>
              <th className="text-left px-3 py-2">Motivo</th>
            </tr>
          </thead>
          <tbody>
            {visibles.map((r) => (
              <tr key={`${r.linea}-${r.email}`} className="border-t">
                <td className="px-3 py-2">{r.linea}</td>
                <td className="px-3 py-2 font-mono text-xs">{r.email}</td>
                <td className="px-3 py-2">
                  <span className={`px-2 py-0.5 rounded text-xs ${BADGE[r.estado]}`}>
                    {r.estado}
                  </span>
                </td>
                <td className="px-3 py-2 text-gray-600">{r.motivo ?? ''}</td>
              </tr>
            ))}
            {visibles.length === 0 && (
              <tr>
                <td colSpan={4} className="px-3 py-6 text-center text-gray-500">
                  Sin filas en este filtro.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
